import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const MealAIInputImage = () => {
    return React.createElement("img", { alt: "", className: css(styles.image), src: "/assets/images/dialog/meal_ai_input.svg" });
};
const styles = StyleSheet.create({
    image: {
        display: 'block',
        width: 327,
        height: 327,
        borderRadius: '8px 8px 0 0',
        flexShrink: 0,
    },
});
